import * as __WEBPACK_EXTERNAL_MODULE__utils_unique_mjs_05bc42ca__ from "../utils/unique.mjs";
const isPlainObject = (obj)=>null != obj && (Object.getPrototypeOf(obj) === Object.prototype || null === Object.getPrototypeOf(obj));
const isProcessableObject = (obj)=>{
    if ('object' != typeof obj || null === obj) return false;
    return isPlainObject(obj) || Array.isArray(obj);
};
const isStubber = (input)=>'function' == typeof input;
const WILDCARD = '*';
const genericLengthStubber = (_property, value)=>{
    let type = typeof value;
    let length = 'unknown';
    if (null == value || 'boolean' == typeof value) return value;
    if ('string' == typeof value) {
        type = 'string';
        length = value.length;
    } else if ('number' == typeof value) {
        type = 'number';
        length = String(value).length;
    } else if (Array.isArray(value)) {
        type = 'array';
        length = value.length;
    } else if (isPlainObject(value)) {
        type = 'object';
        length = Object.keys(value).length;
    }
    return `${type}<${length}>`;
};
const mask = (input, stub, path)=>{
    if (!isProcessableObject(input)) return input;
    const result = Array.isArray(input) ? [
        ...input
    ] : {
        ...input
    };
    const pathParts = path.split('.');
    let current = result;
    const applyStubber = (property, value)=>isStubber(stub) ? stub(property, value) : stub;
    for(let i = 0; i < pathParts.length; i++){
        const nextPathPart = pathParts[i];
        const isLastPart = i === pathParts.length - 1;
        const isNextWildcard = nextPathPart === WILDCARD;
        const next = current[nextPathPart];
        if (isNextWildcard && isLastPart) {
            if (Array.isArray(current)) for(let j = 0; j < current.length; j++)current[j] = applyStubber(j, current[j]);
            else for (const key of Object.keys(current))current[key] = applyStubber(key, current[key]);
            break;
        }
        if (isNextWildcard) {
            const nextPathParts = pathParts.slice(i + 1);
            if (Array.isArray(current)) for(let j = 0; j < current.length; j++)current[j] = isProcessableObject(current[j]) ? mask(current[j], stub, nextPathParts.join('.')) : applyStubber(j, current[j]);
            else {
                const keys = Object.keys(current);
                for (const key of keys)current[key] = isProcessableObject(current[key]) ? mask(current[key], stub, nextPathParts.join('.')) : applyStubber(key, current[key]);
            }
            break;
        }
        if (isLastPart) {
            if (nextPathPart in current) current[nextPathPart] = isStubber(stub) ? stub(nextPathPart, next) : stub;
            break;
        }
        if (!isProcessableObject(next)) break;
        const nextCopy = Array.isArray(next) ? [
            ...next
        ] : {
            ...next
        };
        current[nextPathPart] = nextCopy;
        current = nextCopy;
    }
    return result;
};
const maskMany = (input, stub, paths)=>(0, __WEBPACK_EXTERNAL_MODULE__utils_unique_mjs_05bc42ca__.unique)(paths).reduce((res, field)=>mask(res, stub, field), input);
export { genericLengthStubber, mask, maskMany };

//# sourceMappingURL=mask.mjs.map